module.exports = __webpack_public_path__ + "static/media/google-play-rectangle.e6ac0246.svg";